export default __webpack_public_path__ + "static/media/icon-check.69d6837a.svg";